import { LoadModelService } from '@App/app/engine/services/load-model-service/load-model.service';
import { ModelType } from '@App/app/entities/processing/build-process-status.model';
import { Injectable } from '@angular/core';
import { AssetContainer, ISceneLoaderProgressEvent, Mesh } from 'babylonjs';
import { LODTileInfo } from '../../models/lod-tile-info.model';
import { Tile } from '../../models/tile.model';
import { CustomLodCacheService } from '../custom-lod-cache-service/custom-lod-cache.service';

@Injectable({
  providedIn: 'root',
})
export class CustomLodTileLoaderService {
  constructor(
    private _loadModelService: LoadModelService,
    private _cacheService: CustomLodCacheService,
  ) {}

  async loadTile(
    info: LODTileInfo,
    tileUrl: string,
    assetContainer: AssetContainer | null,
  ): Promise<Tile> {
    const cachedTile = this._cacheService.findByUrl(tileUrl);
    if (cachedTile) return cachedTile;

    let sizeInMB = 0;
    let firstLoadingSize: number | null = null;
    const url = `${tileUrl}?hash=${info.getHash()}&tile=${info.getName()}`;
    const onProgress = (e: ISceneLoaderProgressEvent) => {
      if (!firstLoadingSize) {
        firstLoadingSize = e.total;
      } else if (firstLoadingSize !== e.total) {
        const progress = +(e.loaded / e.total).toFixed(2);
        info.updateProgress(progress);
        sizeInMB = Math.max(sizeInMB, e.total / (1024 * 1024));
      }
    };
    return this._loadModelService
      .loadAssetAsync(url, ModelType.Prod, assetContainer, true, onProgress)
      .then((result) => {
        const meshes = result.meshes as Mesh[];
        const tile: Tile = { url: tileUrl, meshes, sizeInMB };
        this._cacheService.addTile(tile);
        return tile;
      });
  }
}
